import constant from '../../mixins/const';
import axios from "axios";
import abi from "../../mixins/abi";
const BigNumber = require('bignumber.js');
const CryptoJS = require('crypto-js');
const bitcore = require('bitcore-lib');
const bitcoin = require('bitcoinjs-lib');
// const Mnemonic = require('bitcore-mnemonic');
// // const ethers = require('ethers');
// const hdkey = require('ethereumjs-wallet/hdkey');
// const bip39 = require("bip39");

const ethereumJsWallet = require('ethereumjs-wallet');
const ethUtil = require('ethereumjs-util');
const Web3 = require('web3');

const rippleKP = require('ripple-keypairs');
const RippleAPI = require('ripple-lib').RippleAPI;

const settingStoreName = 'settings';
const currencyAccountStoreName = 'currencyAccounts';

const bitcoinHost = constant.blockchainHost.Bitcoin;
const ethereumHost = constant.blockchainHost.Ethereum;
const rippleHost = constant.blockchainHost.Ripple;
const blockStreamApiPath = (constant.blockchainEnv == 'test')?'testnet/':'';

const web3 = new Web3(new Web3.providers.HttpProvider(ethereumHost));

/**
 * vwIdb
 * accounts->import済みのアカウント情報を収納
 *
 * settings->optKeyによって収納する情報を分けている
 * ┗currentAccount=>loginId: string(現在選択中のアカウント)
 */
import {activeHistory, currencyData} from '@/mixins/interface';
import format from "@/mixins/format";

const state = {
    // activeHistories: []
}

const getters = {
    // getActiveHistories(state: any) {
    //     return state.activeHistories;
    // },
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },

    getAddress(store: any, getAddressData: {privateKey: string, platform: string}) {
        return new Promise((resolve, reject) => {
            let address = '';
            switch (getAddressData.platform) {
                case 'Bitcoin':
                    const PublicKey = bitcore.PublicKey;
                    const Address = bitcore.Address;
                    const pkey = getAddressData.privateKey;
                    const publicKey = PublicKey(pkey);
                    address = new Address(publicKey, constant.blockchainEnvName.Bitcoin);
                    break;
                case 'Ether':
                case 'ERC20':
                    const wallet = web3.eth.accounts.privateKeyToAccount('0x' + getAddressData.privateKey)
                    address = wallet.address;
                    break;
                case 'Ripple':
                    const keyPair = rippleKP.deriveKeypair(getAddressData.privateKey);
                    console.log('keyPair', keyPair);
                    address = rippleKP.deriveAddress(keyPair.publicKey);
                    break;
                default:
                    break;
            }
            resolve(address);
        });
    },

    getCurrencyAmount(store: any, currencyData: currencyData) {
        return new Promise(async (resolve) => {

            let amount: number;
            let res;
            if (currencyData.type == 1 || currencyData.type == 3) {
                // メイン通貨
                switch (currencyData.platform) {
                    case 'Bitcoin':
                        amount = await store.dispatch('sumBitcoinAmount', currencyData.name);
                        break;
                    case 'Ether':
                        amount = await store.dispatch('getEtherAmount', currencyData.name);
                        break;
                    case 'Ripple':
                        amount = await store.dispatch('getRippleAmount', currencyData.name);
                        break;
                    default:
                        amount = 0;
                        break;
                }
            } else {
                // 2 or 4 ->トークン
                switch (currencyData.platform) {
                    case 'ERC20':
                        //EthereumTokenの場合
                        amount = await store.dispatch('getERC20Amount', currencyData.name);
                        break;
                    default:
                        amount = 0;
                        break;
                }
            }
            if (amount === -1) {
                res = 'error';
            } else {
                res = 'success';
            }

            if (res === 'success') {
                console.log('BACK:残高の取得ができました', currencyData.name, amount);
                currencyData.amount = amount;
                currencyData.initialized = true;
                await store.dispatch('accountModule/updateCurrencyAccountProperty', {account:currencyData, property: ['amount', 'initialized']}, { root: true });
            }
            resolve({status: res, data: currencyData});
        });
    },

    getUnconfirmedAmount(store: any, data: any) {
        const name = data.name;
        const platform = data.platform;
        return new Promise(async (resolve, reject) => {
            // 未確認トランザクションがある場合はその分をマイナス
            let txs;
            if (platform === 'Ether') {
                // Etherの場合は自身のトランザクション＋ERC20の検索の必要がある
                const search = {
                    value: data.address
                }
                console.log('search', search)

                try {
                    txs = await store.dispatch('idbGetByIdx', {
                        stateName: null,
                        storeName: 'unconfirmedTx',
                        indexName: 'address',
                        search: search
                    }, {root: true});
                } catch (e) {
                    txs = [];
                }
            } else {
                // 他の通貨は名前で検索してその通貨の履歴だけ追う
                const search = {
                    value: name
                }
                console.log('search', search)
                try {
                    txs = await store.dispatch('idbGetByIdx', {
                        stateName: null,
                        storeName: 'unconfirmedTx',
                        indexName: 'name',
                        search: search
                    }, {root: true});
                } catch (e) {
                    txs = [];
                }
            }
            console.log('txs', txs);
            let unconfirmed = 0;
            if (txs.length > 0) {
                for(let i=0; i < txs.length; i++) {
                    const tx = txs[i];
                    console.log('tx', tx);
                    if (platform == 'Ether') {
                        const receipt = await web3.eth.getTransactionReceipt(tx.txid);
                        if (receipt == null) {
                            unconfirmed = unconfirmed + tx.fees;
                            if (tx.name == name) {
                                unconfirmed = unconfirmed + tx.amount;
                            }
                        } else {
                            // 確認済み
                            await store.dispatch('idbDelete', {stateName: null, storeName: 'unconfirmedTx', keyValue: [tx.name,tx.txid]}, {root: true});
                        }
                    }
                    else if (platform == 'Bitcoin') {
                        const urlTxInfo = `https://blockstream.info/${blockStreamApiPath}api/tx/${tx.txid}/status`
                        const txData = await axios.get(urlTxInfo);
                        if (!txData.data.confirmed) {
                            unconfirmed = unconfirmed + tx.amount + tx.change + tx.fees;
                        } else {
                            // 確認済み
                            await store.dispatch('idbDelete', {stateName: null, storeName: 'unconfirmedTx', keyValue: [tx.name,tx.txid]}, {root: true});
                        }
                    }
                    // else if (platform == 'Ripple') {
                    //     const api = new RippleAPI({
                    //         server: rippleHost
                    //     });
                    //     await api.connect();
                    //     const res = await api.getTransaction(tx.txid);
                    //     console.log('res', res);
                    //     if (res.outcome.result == 'tecUNFUNDED_PAYMENT') {
                    //         // 失敗。
                    //         await store.dispatch('idbDelete', {stateName: null, storeName: 'unconfirmedTx', keyValue: [tx.name,tx.txid]}, {root: true});
                    //     } else if (res.outcome.result == 'tesSUCCESS') {
                    //         unconfirmed = BigNumber(unconfirmed).plus(tx.amount).plus(tx.fees).toNumber();
                    //     } else {
                    //         // 確認済み
                    //         await store.dispatch('idbDelete', {stateName: null, storeName: 'unconfirmedTx', keyValue: [tx.name,tx.txid]}, {root: true});
                    //     }
                    //     await api.disconnect();
                    // }
                    else if (platform == 'ERC20') {
                        const receipt = await web3.eth.getTransactionReceipt(tx.txid);
                        if (receipt == null) {
                            unconfirmed = BigNumber(unconfirmed).plus(tx.amount);
                        } else {
                            // 確認済み
                            await store.dispatch('idbDelete', {stateName: null, storeName: 'unconfirmedTx', keyValue: [tx.name,tx.txid]}, {root: true});
                        }
                    }
                    // Rippleは即時反映なので不要
                }
            }
            console.log('unconfirmed', unconfirmed);
            resolve(unconfirmed);
        })
    },

    sumBitcoinAmount(store: any, name: string) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, {root: true})
                .then(async function(data: currencyData) {
                    const search = {
                        value: data.accountNumber
                    }
                    const accountData = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'btcAddress', indexName: 'accountNumber', search: search}, {root: true})
                    console.log('accounts amountCheck', accountData);
                    // 全アドレスから残高を取得
                    let amount = 0;
                    for(let idx in accountData) {
                        amount += await store.dispatch('getBitcoinAmount', {account: accountData, index: idx, name: name});
                    }
                    console.log('total satoshi', amount);
                    // 送信未確認残高の取得
                    const unconfirmed = await store.dispatch('getUnconfirmedAmount', {name: name, platform: 'Bitcoin'})
                    // 送信未完了分を引いておく
                    let amountBtc = BigNumber(amount).minus(unconfirmed);
                    // satoshi->btc
                    amountBtc = amountBtc.div(100000000);
                    const res = (amountBtc.toNumber() > 0)? amountBtc.toNumber() : 0;
                    resolve(res);
                })
                .catch(function(e: any) {
                    console.error(e);
                    resolve(-1);
                });
        });
    },

    getBitcoinAmount(store: any, data: {account: any, index: number, name: string}) {
        return new Promise( (resolve, reject) => {
            const address = data.account[data.index].address;

            const apiUrl = `https://blockstream.info/${blockStreamApiPath}api/address/${address}/utxo`;
            axios.get(apiUrl)
            .then(async (utxos) => {
                console.log('response', utxos.data)
                let balances = 0
                for(let i = 0; i < utxos.data.length; i++) {
                    if (utxos.data[i].status.confirmed) {
                        balances = balances + parseInt(utxos.data[i].value);
                    }
                }
                console.log('balance btc', balances, data.account[data.index].amount);

                // 保存してある値と違ったら上書き
                if (balances !== data.account[data.index].amount) {
                    console.log('上書きします',data.name,balances)
                    data.account[data.index].amount = balances;
                    await store.dispatch('idbPut', {stateName: null, storeName: 'btcAddress', data: data.account[data.index]}, {root: true});
                }
                resolve(balances);
            })
            .catch((e: any) => {
                console.error(e);
                resolve(-1);
            });
        });
    },

    getEtherAmount(store: any, name: string) {
        return new Promise((resolve, reject) => {
            console.log('getEtherAmount', web3.version);
            store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, {root: true})
            .then(function(data: currencyData) {
                console.log('getEtherAmount', data);
                console.log('getEtherAmount address', data.address);
                web3.eth.getBalance(data.address, async (error: any, balance: string) => {
                    console.log('ether balance', balance);
                    const unconfirmed = await store.dispatch('getUnconfirmedAmount', {name: name, platform: 'Ether'});
                    const confirmed = parseInt(balance) - unconfirmed;
                    console.log('ether balance', balance);
                    const res = (confirmed > 0)? web3.utils.fromWei(String(confirmed), 'ether') : '0';
                    resolve(res);
                });
            })
            .catch(function(e: any) {
                console.error(e);
                reject(-1);
            });
        });
    },

    getRippleAmount(store: any, name: string) {
        return new Promise((resolve, reject) => {
            store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, {root: true})
            .then(function(data: currencyData) {
                "use strict";
                const api = new RippleAPI({
                    server: rippleHost // Public rippled server hosted by Ripple, Inc.
                });
                console.log('api', api);
                // let info: any = null;
                // let xrpBalance: number = 0;

                api.connect()
                .then(function(c: any) {
                    console.log('connection', api.connection);
                    api.getAccountInfo(data.address)
                    .then(async (info: any) => {
                        await api.disconnect();
                        console.log(info);
                        // // 送信未確認残高の取得
                        // const unconfirmed = await store.dispatch('getUnconfirmedAmount', {name: name, platform: 'Ripple'});
                        // console.log('unconfirmed', unconfirmed)
                        // xrpBalance = BigNumber(parseFloat(info.xrpBalance)).minus(unconfirmed).toNumber();

                        resolve(info.xrpBalance);
                    })
                    .catch(async (e: any) => {
                        console.error(e);
                        await api.disconnect();
                        resolve(0);
                    });

                })
                .catch(function(e: any) {
                    console.error(e);
                    resolve(-1);
                });
            })
            .catch(function(e: any) {
                console.error(e);
                resolve(-1);
            });
        });
    },

    getERC20Amount(store: any, name: string) {
        return new Promise((resolve, reject) => {
            // nameでidbからprivateKeyを引っ張ってきてamountを取得
            store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, {root: true})
            .then(async function(data: currencyData) {
                const contract = new web3.eth.Contract(abi.erc20Abi, data.contractAddress);
                // 残高
                let balance = await contract.methods.balanceOf(data.address).call()
                balance = parseFloat(balance)
                balance = balance / 10 ** data.tokenDecimals;
                resolve(balance);
            })
            .catch(function(e: any) {
                console.error(e);
                reject(0);
            });
        });
    },

    async getERC20Name(store: any, contractAddress: string) {
        const contract = new web3.eth.Contract(abi.erc20Abi, contractAddress);
        return await contract.methods.name().call();
    },
    async getERC20Decimal(store: any, contractAddress: string) {
        const contract = new web3.eth.Contract(abi.erc20Abi, contractAddress);
        return await contract.methods.decimals().call();
    },
    async getERC20Symbol(store: any, contractAddress: string) {
        const contract = new web3.eth.Contract(abi.erc20Abi, contractAddress);
        return await contract.methods.symbol().call();
    },

    getERC20InfoByContractAddress(store: any, contractAddress: string) {
        return new Promise(async (resolve, reject) => {
            const contract = new web3.eth.Contract(abi.erc20Abi, contractAddress);

            // 名前
            let name = await contract.methods.name().call()
            // symbol
            let symbol = await contract.methods.symbol().call()
            // トークンの少数桁数を取得
            let decimals = await contract.methods.decimals().call()
            decimals = parseFloat(decimals)

            // 残高
            // let balance = await contract.methods.balanceOf(address).call()
            // balance = parseFloat(balance)
            // balance = balance / 10 ** decimals;
            const result = {
                name: name,
                symbol: symbol,
                decimals: decimals
            };
            resolve(result);
        });
    },

    async getActiveHistoryData(store: any, name: string) {
        const search = {
            value: name
        }
        const activeHistoryData = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'activeHistories', indexName: 'name', search: search}, {root: true});
        const res = activeHistoryData.sort((a: any, b: any) => {
            return b.block - a.block;
        });
        return res;
    },

    async getSendingHistoryData(store: any, name: string) {
        const search = {
            value: [name, -1]
        }
        const activeHistoryData = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'activeHistories', indexName: 'sending', search: search}, {root: true});
        let addressList: any = [];
        let filtered: any = [];
        for(let data of activeHistoryData) {
            for(let out of data.out) {
                if(!addressList.includes(out.address) && !out.rel) {
                    filtered.push({
                        address: out.address,
                        createdAt: data.blockTime
                    });
                    addressList.push(out.address);
                }
            }
        }
        const sorted = filtered.sort((a: any, b: any) => {
            return b.createdAt - a.createdAt;
        });
        return sorted;
    },

    async getActiveHistories(store: any, name: string) {
        const data: currencyData = await store.dispatch('idbSelect', {stateName: null, storeName: currencyAccountStoreName, keyValue: name}, {root: true});
        let activeHistories = [];
        if (data.platform == 'Bitcoin') {
            activeHistories = await store.dispatch('getBitcoinHistories', {name: data.name, accountNumber: data.accountNumber});
        } else if (data.platform == 'Ether') {
            activeHistories = await store.dispatch('getEtherHistories', {name: data.name, address: data.address});
        } else if (data.platform == 'Ripple') {
            activeHistories = await store.dispatch('getRippleHistories', {name: data.name, address: data.address, subAddress: data.subAddress});
        } else if (data.platform == 'ER20') {
            activeHistories = await store.dispatch('getERC20Histories', {name: data.name, address: data.address, contractAddress: data.contractAddress, decimals: data.tokenDecimals});
        }
        console.log('activeHistories', activeHistories);
        // store.commit('setActiveHistories', result);
        return activeHistories;
    },

    async getBitcoinHistories(store: any, payload: {name: string, accountNumber: number}) {
        try {
            const activeHistoryData = await store.dispatch('getActiveHistoryData', payload.name);
            let maxHavingBlock = 0;
            if (activeHistoryData.length > 0) {
                maxHavingBlock = activeHistoryData[0].block;
            }

            let activeHistories: any = [];
            let keyManager: any = {
                // xxxxxTxid: {
                //     txNumber: 0
                // }
            }
            const search = {
                value: payload.accountNumber
            }
            const addressList = await store.dispatch('idbGetByIdx', {stateName: null, storeName: 'btcAddress', indexName: 'accountNumber', search: search}, {root:true})
            let addressArray = [];
            for(let addrData of addressList) {
                addressArray.push(addrData.address);
            }
            for(let i = 0; i < addressList.length; i++) {
                // アドレスのトランザクション履歴を取得
                // 25の確認済みトランザクション
                const addrData = addressList[i];
                const urlTx = `https://blockstream.info/${blockStreamApiPath}api/address/${addrData.address}/txs`;
                const response = await axios.get(urlTx);
                console.log('address', addrData.address);
                console.log('get active txs', response);
                const transactions = response.data;

                for (let tx of transactions) {
                    console.log('tx', tx);
                    if (tx.status.block_height < maxHavingBlock) {
                        console.log('this block is smaller')
                        continue;
                    }
                    const thisTx = await store.dispatch('idbSelect', {stateName: null, storeName: 'activeHistories', keyValue: [payload.name, tx.txid]}, {root: true});
                    console.log('thisTx', thisTx);
                    if (thisTx != null) {
                        console.log('know this transaction')
                        continue;
                    }
                    // トランザクションの詳細を取得
                    let movement = 0;
                    let idx = 0;
                    if (!(tx.txid in keyManager)) {
                        idx = Object.keys(keyManager).length;
                        keyManager[tx.txid] = {};
                        keyManager[tx.txid].txNumber = idx;

                        // activeHistories.push({
                        //     name: payload.name,
                        //     hash: tx.txid,
                        //     movement: 0,
                        //     block: tx.status.block_height,
                        //     confirmed: (tx.status.confirmed),
                        //     in: [],
                        //     out: []
                        // });
                        let vIn = [];
                        let vOut = [];

                        /**
                         * 送金元側に自身のアドレスがない(receiveFlg === true)ということは
                         * 絶対に受け取り(to←from)
                         * 送金先に自身のアドレスがない場合は
                         * 絶対に送金
                         */
                        let receiveFlg = true;
                        // transactionの送金側の確認
                        for (let i = 0; i < tx.vin.length; i++) {
                            const address = tx.vin[i].prevout.scriptpubkey_address;
                            if (address != undefined) {
                                let rel;
                                if (addressArray.includes(address)) {
                                    receiveFlg = false;
                                    console.log(tx.txid+'/送金元に自身のアドレスを発見。絶対送金先とはいえない');
                                    // 送金元がこのウォレットのアドレスの場合
                                    rel = true;
                                    movement -= tx.vin[i].prevout.value;
                                } else {
                                    // 送金元がこのウォレットのアドレスじゃない場合→
                                    // console.log('in not this', idx, inIdx);
                                    rel = false;
                                }
                                vIn.push({
                                    address: address,
                                    amount: BigNumber(tx.vin[i].prevout.value).div(100000000).toNumber(),
                                    change: 0,
                                    rel: rel
                                });
                            }
                        }

                        let payFlg = true;
                        // transactionの受金側の確認
                        for (let i = 0; i < tx.vout.length; i++) {
                            const address = tx.vout[i].scriptpubkey_address;
                            if (address != undefined) {
                                let change = 0;
                                let rel;
                                if (addressArray.includes(address)) {
                                    payFlg = false;
                                    console.log(tx.txid+'/送金先に自身のアドレスを発見。絶対送金元とは言えない');
                                    if (movement < 0) {
                                        // 資金の移動がマイナスということは出金側も自分のアドレス → つまりおつりの受け渡し
                                        change = 1;
                                    }
                                    // 送金先がこのウォレットのアドレスの場合
                                    movement += tx.vout[i].value;
                                    rel = true;
                                } else {
                                    // 送金先がこのウォレットのアドレスじゃない場合
                                    // console.log('out not this', idx, outIdx);
                                    rel = false;
                                }
                                vOut.push({
                                    address: address,
                                    amount: BigNumber(tx.vout[i].value).div(100000000).toNumber(),
                                    change: change,
                                    rel: rel
                                });
                            }
                        }
                        if (receiveFlg && payFlg) {
                            console.error('おかしいじょうたいです')
                        }
                        else if (receiveFlg) {
                            // 送金元に自分のアドレスがない場合
                            // receiveFlgが立っていたら絶対に受金なのでつじつま合わせ
                            movement = 1;
                        }
                        else if (payFlg) {
                            // 送金先に自分のアドレスがない場合
                            // payFlgが立ってたら絶対に送金側なのでつじつま合わせ
                            movement = -1;
                        }
                        else{
                            // 送金側と受け取り側両方に自分のアドレスがある場合
                            // = 自分が送金しててお釣りに送ってるだけ
                            movement = -1;
                        }
                        activeHistories.push({
                            name: payload.name,
                            hash: tx.txid,
                            movement: movement,
                            block: tx.status.block_height,
                            confirmed: (tx.status.confirmed),
                            in: vIn,
                            out: vOut,
                            fee: BigNumber(tx.fee).div(100000000).toNumber(),
                            blockTime: parseInt(tx.status.block_time)*1000
                        });
                    } else {

                        idx = keyManager[tx.txid].txNumber;
                        console.log('tx readLog exists!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', idx);
                    }
                }
            }
            console.log('activeHistories new!!', activeHistories);
            return await store.dispatch('saveActiveHistory', {
                name: payload.name,
                activeHistories: activeHistories,
                activeHistoryData: activeHistoryData
            });
        } catch (e) {
            console.error(e);
            throw 'cannot get account info/getActiveHistories';
        }
    },

    async getEtherHistories(store: any, payload: {name: string, address: string}) {
        try {
            const activeHistoryData = await store.dispatch('getActiveHistoryData', payload.name);
            let startBlock = 0;
            if (activeHistoryData.length > 0) {
                startBlock = activeHistoryData[0].block;
            }

            console.log('address log', payload.address);
            let etherScanApi = 'api';
            if (constant.blockchainEnv == 'test') {
                etherScanApi = 'api-ropsten';
            }

            const url = 'https://'+etherScanApi+'.etherscan.io/api?module=account&action=txlist&address=' + payload.address + '&startblock=' + String(startBlock) + '&endblock=latest&page=1&offset=10&sort=desc&apikey=' + process.env.VUE_APP_ENV_ETHERSCAN_API_KEY

            const response = await axios.get(url);
            console.log('ether scan api ', response);
            let activeHistories = [];
            for(let tx of response.data.result) {
                console.log('tx', tx);
                if (tx.blockNumber < startBlock) {
                    console.log('this block is smaller')
                    continue;
                }
                const thisTx = await store.dispatch('idbSelect', {stateName: null, storeName: 'activeHistories', keyValue: [payload.name, tx.hash]}, {root: true});
                if (thisTx != null) {
                    console.log('know this transaction')
                    continue;
                }
                const amount = web3.utils.fromWei(String(tx.value), 'ether');
                let movement = 0;
                if (tx.to == payload.address) {
                    movement = 1;
                } else {
                    movement = -1;
                }
                const vIn: any = [{
                    id: 0,
                    address: tx.from,
                    amount:amount,
                    change: 0
                }];
                const vOut: any = [{
                    id: 0,
                    address: tx.to,
                    amount: amount,
                    change: 0
                }];

                const feeWei = Number(tx.gasPrice) * Number(tx.gasUsed);

                activeHistories.push({
                    name: payload.name,
                    hash: tx.hash,
                    in: vIn,
                    out: vOut,
                    movement: movement,
                    block: tx.blockNumber,
                    confirmed: true,
                    fee: web3.utils.fromWei(String(feeWei), 'ether'),
                    blockTime: parseInt(tx.timeStamp)*1000
                });
            }
            console.log('activeHistories', activeHistories);
            return await store.dispatch('saveActiveHistory', {
                name: payload.name,
                activeHistories: activeHistories,
                activeHistoryData: activeHistoryData
            });

        } catch(e) {
            // web3.eth.getBlock('latest', true)
            // .then(async (block: any) => {
            //     console.log('block', block);
            //     for(let i = block.number;i < 1;i--) {
            //         // 1blockずつtransactionhashを拾ってその中身を見ていく
            //     }
            //     return [];
            // })
            // .catch((e: any) => {
            //     console.error(e);
            //     throw 'cannot get account info/getActiveHistories';
            // });
            throw 'api error';
        }
    },

    async getRippleHistories(store: any, payload: {name: string, address: string, subAddress: string}) {
        try {
            const api = new RippleAPI({
                server: rippleHost
            });
            await api.connect();

            const activeHistoryData = await store.dispatch('getActiveHistoryData', payload.name);

            const serverInfo = await api.getServerInfo();
            const ledgers = serverInfo.completeLedgers.split('-');
            console.log('ledgers', ledgers);
            let minLedgerVersion = Number(ledgers[0]);
            if (activeHistoryData.length > 0) {
                minLedgerVersion = activeHistoryData[0].block;
            }
            const maxLedgerVersion = Number(ledgers[1]);
            console.log('ledger min', minLedgerVersion);
            console.log('ledger max', maxLedgerVersion);

            const transactions = await api.getTransactions(payload.address, {
                minLedgerVersion,
                maxLedgerVersion,
                limit: 20
            });
            console.log('transactions', transactions);

            let activeHistories: any = [];
            for(let tx of transactions) {
                console.log('tx', tx);
                if (tx.outcome.ledgerVersion < minLedgerVersion) {
                    console.log('this block is smaller')
                    continue;
                }
                const thisTx = await store.dispatch('idbSelect', {stateName: null, storeName: 'activeHistories', keyValue: [payload.name, tx.id]}, {root: true});
                if (thisTx != null) {
                    console.log('know this transaction')
                    continue;
                }
                let movement;
                if (tx.specification.source.address != payload.address && tx.specification.source.address != payload.subAddress) {
                    movement = 1;// 受け取り
                } else {
                    movement = -1;// 送金
                }
                activeHistories.push({
                    name: payload.name,
                    hash: tx.id,
                    in: [{
                        id: 0,
                        address: tx.specification.source.address,
                        amount: tx.outcome.deliveredAmount.value,
                        change: 0
                    }],
                    out: [{
                        id: 0,
                        address: tx.specification.destination.address,
                        amount: tx.outcome.deliveredAmount.value,
                        change: 0
                    }],
                    movement: movement,
                    block: tx.outcome.ledgerVersion,
                    confirmed: (tx.outcome.result === 'tesSUCCESS'),
                    fee: tx.outcome.fee,
                    blockTime: format.getBlockTime(tx.outcome.timestamp, 'ISO')
                });
            }
            await api.disconnect();

            return await store.dispatch('saveActiveHistory', {
                name: payload.name,
                activeHistories: activeHistories,
                activeHistoryData: activeHistoryData
            });
        } catch (e) {
            throw 'ripple get txs error';
        }
    },

    async getERC20Histories(store: any, payload: {name: string, address: string, contractAddress: string, decimals: number}) {
        const activeHistoryData = await store.dispatch('getActiveHistoryData', payload.name);
        let fromBlock = 0;
        if (activeHistoryData.length > 0) {
            fromBlock = activeHistoryData[0].block;
        }
        const contract = new web3.eth.Contract(abi.erc20Abi, payload.contractAddress);
        contract.getPastEvents("Transfer", {
            fromBlock: fromBlock,
            toBlock: 'latest',
            filter: {from: payload.address}
        })
        .then(async (outEvents: any) => {
            let activeHistories = [];
            // 出金
            if (outEvents) {
                for (let event of outEvents) {
                    console.log('outevent', event);
                    if (event.blockNumber < fromBlock) {
                        console.log('this block is smaller')
                        continue;
                    }
                    const thisTx = await store.dispatch('idbSelect', {stateName: null, storeName: 'activeHistories', keyValue: [payload.name, event.transactionHash]}, {root: true});
                    if (thisTx != null) {
                        console.log('know this transaction')
                        continue;
                    }
                    const amount = BigNumber(event.returnValues.value).div(10 ** payload.decimals).toNumber()
                    let movement = 0;
                    if (event.returnValues.to == payload.address) {
                        movement = 1;
                    } else {
                        movement = -1;
                    }
                    const vIn = [{
                        id: 0,
                        address: event.returnValues.from,
                        amount: amount,
                        change: 0
                    }];
                    const vOut = [{
                        id: 0,
                        address: event.returnValues.to,
                        amount: amount,
                        change: 0
                    }];
                    const tx = await new web3.eth.getTransaction(event.transactionHash);
                    const feeWei = tx.gasPrice * tx.gas;

                    activeHistories.push({
                        name: payload.name,
                        hash: event.transactionHash,
                        in: vIn,
                        out: vOut,
                        movement: movement,
                        block: event.blockNumber,
                        confirmed: true,
                        fee: web3.utils.fromWei(String(feeWei), 'ether')
                    })

                }
            }

            return await store.dispatch('saveActiveHistory', {
                name: payload.name,
                activeHistories: activeHistories,
                activeHistoryData: activeHistoryData
            });
        })
    },

    async saveActiveHistory(store: any, payload: any) {
        let activeHistories = payload.activeHistories;
        const activeHistoryData = payload.activeHistoryData;
        if (activeHistories.length > 0) {
            activeHistories = activeHistories.sort((a: any, b: any) => {
                return b.block - a.block;
            });
            activeHistories = activeHistories.slice(0, 20);
        }
        const totalLength = activeHistoryData.length + activeHistories.length;
        const sa = totalLength - 20;
        if (sa > 0) {
            // saが1の場合は1,20でsliceせなあかん
            const deleteData = activeHistoryData.slice(sa, 20);
            for (let del of deleteData) {
                await store.dispatch('idbDelete', {stateName: null, storeName: 'activeHistories', keyValue: [del.name, del.hash]}, {root:true})
            }
        }
        if (activeHistories.length > 0) {
            for (let activeHistory of activeHistories) {
                await store.dispatch('idbPut', {stateName: null, storeName: 'activeHistories', data: activeHistory}, {root: true})
            }
        }
        // 再取得
        return await store.dispatch('getActiveHistoryData', payload.name);
    }
}

const mutations = {
    setActiveHistories(state: any, payload: any) {
        state.activeHistories = payload;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
